import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api__getFinancePostData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(postId) {
    var _res$data;
    var params, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = {
            id: postId,
            thumb_size: 300,
            device_type: "web",
            include: "details,price,gallery,g4Data"
          };
          _context.next = 3;
          return fetcher().get("/post/view-online", {
            params: params
          });
        case 3:
          res = _context.sent;
          if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.data) {
            res.data.data.post_id = postId;
          }
          return _context.abrupt("return", res);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__getFinancePostData(_x) {
    return _ref.apply(this, arguments);
  };
}();